import { Box, Link, Stack, Typography } from '@ace-clublabs/shared-component-library';
import { getFullDigitalDisclaimer } from '../../utils/helpers';
import { MembershipAppStateContext } from '../MembershipAppState/MembershipAppState';
import { useContext } from 'react';

export const PaperlessDisclaimer = () => {
  const { membershipInfo } = useContext(MembershipAppStateContext);

  return (
    <Box
      sx={{
        margin: '1rem 0',
      }}
    >
      <Stack className="full-digital-section">
        <Typography variant="b3Regular">
          {getFullDigitalDisclaimer(membershipInfo?.clubCode ?? '')} See{' '}
          <Link
            className="benefit-link"
            href="https://www.ace.aaa.com/legal/paperless-terms-and-conditions.html"
            target="_blank"
            variant="b3Regular"
          >
            Terms and Conditions
          </Link>
          . You can update your settings anytime in{' '}
          <Link
            className="benefit-link terms-condition-link"
            href={`https://account.app.ace.aaa.com`}
            target="_blank"
            variant="b3Regular"
          >
            My Account
          </Link>
          .
        </Typography>
      </Stack>
    </Box>
  );
};
